import {
  ProceedButton,
  Title,
  Footer,
  Content,
  Description,
} from "./Common/Common";
import Header from "./Header/Header";
import ProgressBar from "./ProgressBar/ProgressBar";

export {
  Header,
  ProgressBar,
  ProceedButton,
  Title,
  Footer,
  Content,
  Description,
};
